import React from 'react';
import { Grid, Box, Divider } from '@mui/material';
import { WelcomeGiftStore, WelcomeGiftTypes } from '@gamiphy/loyalty-station-desktop/store/welcomeGift';
import { observer } from 'mobx-react';
import { Trans } from '@gamiphy/react-i18n';
import { WelcomeDiscountCoupon } from '../discountCoupon';
import Lock from './assets/Lock.svg';

type Props = {
  className?: string
}

const WelcomeReward: React.FC<Props> = observer(({ className }) => {
  switch (WelcomeGiftStore.type) {
    case WelcomeGiftTypes.discount:
      return <WelcomeDiscountCoupon className={className} />;
    case WelcomeGiftTypes.points:
      return (
        <Grid
          justifyContent="center"
          alignItems="center"
          sx={{
            minHeight: '96px',
            background: 'linear-gradient(143.1deg, #FFCD4E 4.79%, #FBB400 133.39%)',
            borderRadius: '6px',
            py: 2,
            px: 0.5,
            boxShadow: '0px 4px 4px rgba(255, 205, 78, 0.34)',
          }}
          container
        >
          <Grid item container direction="column" sx={{ color: 'text.primary' }}>
            <Grid container item alignItems="center" justifyContent="center">
              <Grid item sx={{ mr: 1 }}>
                <Box component="img" src={Lock} />
              </Grid>
              <Grid item sx={{ fontSize: '18px', fontWeight: 700 }}>
                <Trans
                  i18nKey="welcomePoints.getWelcomePoints"
                  defaults="Get {{gems, gems}}"
                  values={{
                    gems: WelcomeGiftStore.total,
                  }}
                />
              </Grid>
            </Grid>
            <Divider sx={{ my: 0.5 }} />
            <Grid item sx={{ fontSize: '14px', textAlign: 'center', '&:first-letter': { textTransform: 'capitalize' } }}>
              <Trans
                i18nKey="welcome.points"
                defaults="Welcome {{, gems}}"
                values={{}}
              />
            </Grid>
          </Grid>
        </Grid>
      );
    default:
      return null;
  }
});

export default WelcomeReward;
